import { DatePicker } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { FormControlPropsSizeOverrides, TextField, FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export interface WsDatePickerProps {
  name: string;
  label: string;
  size?: OverridableStringUnion<'small' | 'medium', FormControlPropsSizeOverrides>;
  disabled?: boolean;
  required?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

const WsDatePicker = ({
  name,
  label,
  size,
  required,
  disabled,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
}: WsDatePickerProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <FormControl fullWidth size={size} required={required} disabled={disabled}>
      <Controller
        render={({ field: { onChange, value = null } }) => (
          <LocalizationProvider dateAdapter={DateAdapter}>
            <DatePicker
              label={label}
              disableFuture={disableFuture}
              disablePast={disablePast}
              minDate={minDate}
              maxDate={maxDate}
              value={value ?? null}
              onChange={onChange}
              allowSameDateSelection
              renderInput={(params) => <TextField size={size} required={required} {...params} />}
              disabled={disabled}
              inputFormat="dd/MM/yyyy"
            />
          </LocalizationProvider>
        )}
        control={control}
        name={name}
      />
      {errors && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
    </FormControl>
  );
};
export default WsDatePicker;
